// src/UserTable.js

import React, { useState, useEffect } from 'react';
import { Table, Space, Button, Card, Layout, Menu } from 'antd';
import {Link, useLocation} from 'react-router-dom';

import Sidebar from './Side_Bar/Admin_Side_Bar';

const { Sider} = Layout;

const UserTable = () => {
  const [userData, setUsersData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  const mainUrl                       = "https://chatbot-summary-deployment-dot-fartech-yvqj.et.r.appspot.com/";
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${mainUrl}/getAllTable?tableName=User`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setUsersData(data);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching table data:', error);
        throw error;
      }
    };

    fetchData();
  }, [])

  // Columns for the table
  const columns = [
    {
      title: 'Username',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Password',
      dataIndex: 'password',
      key: 'password',
      render: (text, record) => (
        <span style={{ display: 'inline-block', width: '100%' }}>
          {'****************** '}
          <span style={{ color: 'red' }}>Passwords cannot be viewed.</span>
        </span>
      ),
    },
    {
      title: 'Role',
      dataIndex: 'user_type',
      key: 'user_type',
    },
  ];

  if (isLoading) {
    return <p>Loading...</p>;
  }

  return (
    <Layout style={{ minHeight: '98vh' }}>
       <Sidebar location={location} />
        <Layout>
          <div style={{ maxWidth: '1200px', margin: '30px', textAlign: 'center', fontFamily: 'Helvetica, Arial, sans-serif' }}>
            <Card title={<span style={{ fontSize: '20px' }}>User Information</span>} style={{ maxWidth: '1200px' }}>
                <Table dataSource={userData} columns={columns} />
            </Card>
          </div>
        </Layout>
      </Layout>
  );
};


export default UserTable;
